$(document).ready(function(){
  
$('.block__blog-content-blogs').not('.slick-initialized').slick({
    slidesToShow:3,
    slidesToScroll:1,
    autoplay: true,
    infinite:true,    
  	arrows: true,
    adaptiveHeight: true,
    responsive: [
    {
      breakpoint: 1199,
      settings: {
      slidesToShow: 2, 
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '160px',
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '80px'
      }
    },
      {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '40px'
      }
    },
      {
      breakpoint: 430,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '20px'
      }
    } 
  ]
  }); 
$('.block__blog-titletag-main .block__blog-titletag').click(function(){
    var data_tag_blog = $(this).attr('data-tag-blog');
    $(this).parents('.block__blog-titletag-main').find('.block__blog-titletag').removeClass('block__blog-active');
    $(this).parents('.block_section-blogs-content').find('.block__blog-content-wrapper').removeClass('block__blog-active').css('display', 'none'); // Remove the class and fade out all subcategories
    $(this).addClass('block__blog-active');
    $(this).parents('.block_section-blogs-content').find('.block__blog-content-wrapper[data-tag-blog-content="'+data_tag_blog+'"]').fadeIn(600).addClass('block__blog-active').css('display', 'block');
          setTimeout(function(){
          $('.block__blog-content-blogs').slick('refresh');
        },40);    
  });
  
}); 